import { _WEB_VERSION } from './constant';
// export const _BASE_URL = 'http://localhost:29316'; // Stage
export const _BASE_URL = 'https://api.logohouse.art'; // Production

const Routes = {
    _ACCOUNT_LOGIN: '/account/login',
    _USER_REGISTER: '/account/register',
    _FORGOT_PASSWORD: '/user/forgot-password',
    _CHANGE_PASSWORD: '/user/change-password',
    _ACCOUNT_VERIFY: 'account/verify',
    _ACCOUNT_LOGOUT: '/account/logout',
    _ACCOUNT_IS_LOGGED_IN: '/account/is-logged-in',
    _ACCOUNT_RESET_PASSWORD: '/account/password',
    _ACCOUNT_UPDATE_STATUS: '/account/status',
    _MEMBER: '/member',
    _ORDER_HISTORY: '/order/history',
    _ORDER_HISTORY_SUMMARY: '/order/history/summary',
    _ORDER_HISTORY_DOWNLOAD: '/order/history/download-order',
};

export default Routes;